import styles from './logo.module.css'


export const Logo = () => {
    return <a href="/" className={styles.logo}>
            pearch
    </a>
}